<script>
  export let id;
  export let path =
    "M6.00 2.00 C 6.00 2.00, -2.00 20.00, 6.00 26.00 C 14.00 32.00, 30.00 20.00, 38.00 26.00 C 46.00 32.00, 38.00 50.00, 38.00 50.00";

  let pathArr = path.replace(/[^\d\W]/gi, "").split(" ");
  const [startStrX, startStrY, ...pathRemArr] = pathArr;
  const [endStrY, endStrX] = pathRemArr.reverse();

  const startX = parseFloat(startStrX, 10);
  const startY = parseFloat(startStrY, 10);
  const endX = parseFloat(endStrX, 10);
  const endY = parseFloat(endStrY, 10);
</script>

<style lang="scss">
  $colorSecondary: #fbab61;
  $colorTertiary: #e0654f;

  div {
    position: absolute;
    // outline: 1px dotted white;
    font-size: 0px;
    z-index: 1;

    svg {
      width: 100%;
      height: 100%;
      overflow: visible;

      path {
        fill: none;
        stroke: #aac4e5;
        stroke-width: 2;
        stroke-linecap: butt;
        stroke-linejoin: miter;
        stroke-miterlimit: 4;
        vector-effect: non-scaling-stroke;
      }

      line {
        stroke-linecap: round;
        stroke-width: 6;
        vector-effect: non-scaling-stroke;
        stroke: $colorSecondary;

        &:nth-of-type(2) {
          stroke: $colorTertiary;
        }
      }
    }
  }
</style>

<div data-shape="TLBR" {id} style="width: {startX - endX}px; height: {startY - endY}px">
  <svg viewBox="{startX} {startY} {endX - startX} {endY - startY}" preserveAspectRatio="none">
    <path id={`${id}__path`} class="path" d={path} />
    <line id={`${id}__dot1`} class="dot1" x1={`${startX}`} x2={`${startX}`} y1={`${startY}`} y2={`${startY}`} />
    <line id={`${id}__dot2`} class="dot2" x1={`${endX}`} x2={`${endX}`} y1={`${endY}`} y2={`${endY}`} />
  </svg>
</div>
